import { ReserveFormState } from "@v2/reserve/types";
import React from "react";

export const ReserveFormContext = React.createContext<
  | (ReserveFormState & {
      isOnReservationModal?: boolean;
      isReservationCardIsOpen?: boolean;
    })
  | null
>(null);

export const useReserveForm = () => {
  const context = React.useContext(ReserveFormContext);
  if (!context) {
    throw new Error("useReserveForm must be used within a ReserveFormProvider");
  }
  return context;
};

export const useOptionalReserveForm = () => {
  return React.useContext(ReserveFormContext);
};
